import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';

const STooltip = withStyles(() => ({
  tooltip: {
    color: 'white',
    fontFamily: 'Texta, Arial, Helvetica, sans-serif',
    fontWeight: 600,
    marginTop: 4,
    backgroundColor: 'rgba(25, 32, 45, 0.75)',
    fontSize: 12,
  },
}))(Tooltip);

export default STooltip;
